import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', e => {

    const carousels = document.querySelectorAll('.product-see-also');

    if (carousels) {
        //console.info(carousels);
        carousels.forEach(carousel_block => {

            const list = carousel_block.querySelector('.product-see-also__list');
            const next = carousel_block.querySelector('.product-see-also__next') || null;
            const prev = carousel_block.querySelector('.product-see-also__prev') || null;
            const blockWidth = carousel_block.offsetWidth;

            const baseBreakpoints = {
                440: {
                    slidesPerView: 2,
                    spaceBetween: 8,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 8,
                },
                991: {
                    slidesPerView: 3.5,
                    spaceBetween: 8,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 8,
                },
            };

            const finalBreakpoints = { ...baseBreakpoints };

            // console.info(list, next, prev);
            const swiper = new Swiper(list, {
                loop: true,
                loopPreventsSliding: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                slidesPerView: 2,
                spaceBetween: 8,
                // autoHeight: true,
                breakpoints: finalBreakpoints
            });

            // Динамически добавляем breakpoint, если ширина блока позволяет
            if (blockWidth > 1200) {
                swiper.params.breakpoints[1400] = { slidesPerView: 5, spaceBetween: 8 };
                swiper.update();
            }
        });
    }


});
